import cn from "@/utils/class-names";
import { Box, Text } from "rizzui";

interface StatBoxProps {
  label: string;
  description?: string;
  value: string | number;
  className?: string;
}

export default function StatBox({
  label,
  value,
  description,
  className = "",
}: StatBoxProps) {
  return (
    <Box className={cn(`rounded-lg border-0 px-5 py-3`, className)}>
      <Text className="text-base font-semibold text-gray-600">{label}</Text>
      {description && (
        <Text className="text-xs text-gray-600">{description}</Text>
      )}
      <Text className="text-xl font-semibold mt-2">{value}</Text>
    </Box>
  );
}
